import { useEffect, useState } from 'react';

import { FormalOffer } from '../MyOffers.types';

export const ORIGINAL_RATE_DISPLAY = '2,99 %';

export const useGetDiscountedPrice = ({
    formalOffer,
    enabled
}: {
    formalOffer: FormalOffer | null | undefined;
    enabled: boolean;
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [hasDiscountedPricing, setHasDiscountedPricing] = useState(false); // add state for this.

    useEffect(() => {
        if (enabled) {
            setIsLoading(true);
            try {
                if (
                    formalOffer &&
                    formalOffer.interest_rates &&
                    formalOffer.interest_rates[0] &&
                    formalOffer.interest_rates[0].rate
                ) {
                    const interestRate = formalOffer.interest_rates[0].rate;
                    setHasDiscountedPricing(interestRate <= 0.0245);
                } else {
                    setHasDiscountedPricing(false);
                }
                setIsLoading(false);
                setHasError(false);
            } catch (error) {
                setIsLoading(false);
                setHasError(Boolean(error));
                setHasDiscountedPricing(false);
            }
        } else {
            setIsLoading(false);
            setHasError(false);
            setHasDiscountedPricing(false);
        }
    }, [enabled, formalOffer]);

    return {
        loading: isLoading,
        error: hasError,
        hasDiscountedPricing: hasDiscountedPricing,
        discountedPrice: null
    };
};
